import React from 'react';
import BlogDraftSection from '../../../../sections/AdminDashboard/Content/Blog/BlogDraft';

const BlogDraft = () => {
  return <BlogDraftSection />;
};

export default BlogDraft;

